import React from 'react';

import { DropdownMenuItem } from 'ui-components/components/dropdown-menu-item';

import styles from './styles.module.less';
import { emptyArray } from 'ui-components/default-props/empty';

/**
 * @param {object} props
 * @param {any[]|Readonly<any[]>} props.items
 * @param {(name: string) => void} props.onChange
 * @returns {JSX.Element}
 */
export const ItemsDropdown = ({ items = emptyArray, onChange }) => {
  return (
    <div className={styles['result-dropdown-menu']}>
      {items.map((i) => {
        return (
          <div key={i.key} className={styles['result-item']}>
            <DropdownMenuItem key={i.key} className={styles['menu-item']} onClick={() => onChange(i.name)}>
              {i.name}
            </DropdownMenuItem>
          </div>
        );
      })}
    </div>
  );
};
